var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav",on:{"click":function($event){return _vm.$router.push(_vm.to)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"arrow-left"}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }